<template>
  <div class="c-material-report">
    <report-filter ref="filter" @on-change="filterData" @on-search="searchFilterData" />
    <div class="c-m-table">
      <div class="c-table-list">
        <div>
          <QueryParamsManager
            ref="queryParamsManager"
            menu-id="M20997"
            :max-conditions="20"
            @select="onConditionSelect"
            @request-save="onSaveRequest"
          />
          <el-button v-if="permission.includes('M21016')" type="text" style="margin-left: 10px" @click="showGameLevelSetting"
            >游戏等级通关率设置</el-button
          >
        </div>

        <div class="right-btns">
          <SummaryDimensionSelector
            v-model="middleWareFlag"
            @change="$refs.filter.sendEvent()"
            style="margin-right: 10px"
          ></SummaryDimensionSelector>
          <div class="empty-data-filter">
            <el-switch v-model="emptyFilterSwitch" @change="$refs.filter.sendEvent()"></el-switch>
            <span>&ensp;过滤消耗为0数据</span>
          </div>
          <el-radio-group class="date-type-radio" v-model="dateType" @change="handlerDateType">
            <el-radio-button :label="DATE_TYPE.HOUR">分时</el-radio-button>
            <el-radio-button :label="DATE_TYPE.DAY">分日</el-radio-button>
            <el-radio-button :label="DATE_TYPE.WEEK">分周</el-radio-button>
            <el-radio-button :label="DATE_TYPE.MONTH">分月</el-radio-button>
            <el-radio-button :label="DATE_TYPE.TOTAL">汇总</el-radio-button>
          </el-radio-group>

          <div class="date-picker-wrapper">
            <DateRangePicker
              v-if="dateType === DATE_TYPE.DAY || dateType === DATE_TYPE.TOTAL || dateType === DATE_TYPE.HOUR"
              v-model="datetime"
              style="width: 220px"
              :clearable="false"
              :pickerOptions="{ disabledDate }"
              @change="onDateRangeChange"
            ></DateRangePicker>

            <div>
              <dateWeekRange
                v-if="dateType === 2"
                v-model="weekRange"
                range-separator="至"
                style="width: 180px"
                start-placeholder="开始周"
                end-placeholder="结束周"
                :default-value="WeekDefaultShow"
                :picker-options="weekOptions"
                @change="onDateRangeChange"
                popper-class="week-range"
              >
              </dateWeekRange>
            </div>
            <div>
              <el-date-picker
                v-if="dateType === 3"
                v-model="monthRange"
                type="monthrange"
                range-separator="至"
                style="width: 180px"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                :default-value="MonthDefaultShow"
                :picker-options="monthOptions"
                @change="onDateRangeChange"
              >
              </el-date-picker>
            </div>
          </div>
          <CustomColumnDropdownBtn
            ref="tableCustomColsRef"
            name="effectDataCustomColumn"
            menu-id="M20997"
            :extend-id="1"
            :col-list="defaultTableCols"
            :navs="defaultTableColNavs"
            @change="onCustomColumnChange"
          ></CustomColumnDropdownBtn>

          <el-button icon="el-icon-download" style="margin-left: 5px" @click="downData" :loading="exportLoading">数据导出</el-button>
        </div>
      </div>
      <p-detail-table
        ref="planDataTable"
        :loading="loading || toggleTableColLoading"
        :data="tableList"
        :columns="tableCols"
        :summary="summaries"
        @on-sort="sortTable"
        @on-show="handleShow"
        @header-dragend="headerDragend"
        @on-refresh="getData"
      />

      <el-pagination
        :total="total"
        :current-page.sync="pageIndex"
        :page-size="pageSizePrivate"
        :page-sizes="[10, 20, 30, 40, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="changePageIndex"
        @size-change="changePageSizePrivate"
        class="c-table-page pager"
        background
      />
    </div>

    <el-dialog custom-class="game-level-modal" title="游戏等级通关率设置" :visible.sync="gameLevelSettingModal" width="810px">
      <el-form ref="game-level-form" label-width="74px" class="game-level-form" :model="gameLevelForm">
        <el-form-item>
          <div class="title-row">
            <h3>游戏选择</h3>
            <h3>平台</h3>
            <h3>首日游戏等级</h3>
            <h3>1小时游戏等级</h3>
          </div>
        </el-form-item>
        <el-form-item
          :label="index === 0 ? '游戏设置' : ''"
          v-for="(gameItem, index) in gameLevelForm.rows"
          :key="index"
          :prop="`rows.${index}.middleGameIds`"
          :rules="gameLevelRules"
        >
          <div class="game-row">
            <div class="selector">
              <el-select v-model="gameItem.middleGameIds" filterable placeholder="请选择中间件游戏">
                <el-option
                  v-for="item in midGameData"
                  :disabled="disableExistGameItem(item.id, gameItem)"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>

              <el-select v-model="gameItem.platform" filterable placeholder="请选择平台">
                <el-option
                  v-for="item in [
                    { id: 2, name: 'IOS' },
                    { id: 1, name: '安卓' },
                    { id: 3, name: '小程序' }
                  ]"
                  :disabled="disableExistPlatformItem(item.id, gameItem)"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>

              <el-input v-model="gameItem.level" placeholder="游戏等级，0-9999"></el-input>
              <div class="suffix">&ensp;级</div>
              <el-input v-model="gameItem.hourLevelPass" placeholder="游戏等级，0-9999"></el-input>
              <div class="suffix">&ensp;级</div>
            </div>
            <div class="btns" v-if="gameLevelForm.rows.length > 1">
              <span class="el-icon-error" @click="onGameLevelRowRemove(index)"></span>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="add-row">
        <el-button type="text" @click="onAddGameLevelRow">+添加游戏</el-button>
      </div>
      <div slot="footer">
        <el-button @click="closeGameLevelSettingModal">取 消</el-button>
        <el-button type="primary" @click="onGameLevelSettingConfirm" :loading="gameLevelForm.loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { isEmpty } from '@/common/js/utils'
import { REPORT_COMPLEX } from '@/views/download-center/data/const.js'
import mixinTable from './js/mixin_table'
import QueryParamsManager from '@/components/query-params-manager/index.vue'
import ReportFilter from './components/report-filter.vue'
import PDetailTable from './components/effect-table.vue'
import { checkedDataForComplex, dimensionsData } from './js/dimensionsData.js'
import DEFAULT_COLS, { NAVS, BASIC_DATA_SHOW_IN_PACKAGE_DIMENSION } from './data/table-cols.js'

import DateRangePicker from '@/components/date-range-picker/index.vue'
import CustomColumnDropdownBtn from '@/components/custom-column-v2/dropdown-btn.vue'
import SummaryDimensionSelector from './components/summary-dimension-selector.vue'

import { getComplexReport, initDownloadCenterTask, setGameLevel, getGamePassLevelConfig } from '@/api/report.model'
import { getMiddleGameList } from '@/api/common.model'

import { toThousands, toPercentFixed } from '@/common/js/filters'
import { thousands } from './js/judge-table'

const DATE_TYPE = {
  HOUR: 0,
  DAY: 1,
  WEEK: 2,
  MONTH: 3,
  TOTAL: 4
}
const getGameLevelRow = () => ({ middleGameIds: '', platform: '', level: '', hourLevelPass: '' })
export default {
  name: 'effect-report',
  mixins: [mixinTable],
  components: { PDetailTable, QueryParamsManager, ReportFilter, DateRangePicker, CustomColumnDropdownBtn, SummaryDimensionSelector },
  computed: {
    permission() {
      return this.$store.state.accessAuth || []
    },

    tableCols() {
      const firstCol = {
        title: this.getDateType(this.dateType),
        key: 'tdate',
        type: 'disabled',
        width: 100,
        fixed: true
      }

      // v4.22.1 为分日分周分月新增排序
      if ([DATE_TYPE.DAY, DATE_TYPE.WEEK, DATE_TYPE.MONTH].includes(this.dateType)) {
        firstCol.sortable = 'custom'
      }

      // 如果带有维度查询，表格列前面新增对应的列显示；
      const dimensionCols = this.addOnDimensions.map((col) => {
        // v4.43 计划 平台 人员 素材 媒体 账号 游戏 增加排序
        if (
          ['planName', 'platform', 'opName', 'imageName', 'mediaName', 'subMediaName', 'adAccountName', 'gameName', 'deliveryTypeName'].includes(
            col.key
          )
        ) {
          col.sortable = 'custom'
        }
        return { ...col, fixed: true, checked: true }
      })
      const addCols = [firstCol, ...dimensionCols]

      const middleWareExcludeColTitleList = BASIC_DATA_SHOW_IN_PACKAGE_DIMENSION.map((c) => c.title)
      const tableColumns = this.tableColumns.filter((c) => {
        // 当分周、分月日期类型时，不显示新创角累计天数
        if ([DATE_TYPE.WEEK, DATE_TYPE.MONTH].includes(this.dateType)) {
          return c.checked && c.title !== '新创角累计天数'
        }
        if (this.middleWareFlag) {
          // 中间件不展示的列
          if (middleWareExcludeColTitleList.includes(c.title)) {
            return false
          }
        }

        return c.checked
      })

      return [...addCols, ...tableColumns]
    }
  },
  methods: {
    /**
     * @description: 通过游戏id+平台id判断是否存在相同项，如果存在则不可添加
     * @param {*} gameId
     * @param {*} gameItem
     */
    disableExistGameItem(gameId, gameItem) {
      const existGroups = this.gameLevelForm.rows.filter((r) => !!r.platform).map((r) => `${r.middleGameIds}-${r.platform}`)
      const needle = `${gameId}-${gameItem.platform}`
      return existGroups.includes(needle)
    },
    /**
     * @description: 通过游戏id+平台id判断是否存在相同项，如果存在则不可添加
     * @param {*} platform
     * @param {*} gameItem
     */
    disableExistPlatformItem(platform, gameItem) {
      const existGroups = this.gameLevelForm.rows.map((r) => `${r.middleGameIds}-${r.platform}`)
      const needle = `${gameItem.middleGameIds}-${platform}`
      return existGroups.includes(needle)
    },

    query() {
      this.$refs.filter.sendEvent()
    },
    handlerDateType(val) {
      switch (val) {
        case DATE_TYPE.WEEK:
          {
            // 默认周一到周天
            let monday = moment().weekday(0)
            let lastday = moment().weekday(6)
            // v4.22.1 如果今天是星期一，取上周一到上周天
            if (moment().day() === 1) {
              monday = moment().weekday(-7)
              lastday = moment().weekday(-1)
            }
            this.weekRange = [monday.format('YYYY-MM-DD'), lastday.format('YYYY-MM-DD')]
          }
          break

        case DATE_TYPE.MONTH:
          {
            // v4.22.1 例如今天是1月1日，则选中的是上月
            // 例如今天是1月2日，则选中的是本月
            let month = moment().format('YYYY-MM-01')
            const today = moment().format('YYYY-MM-DD')
            if (today.endsWith('-01')) {
              month = moment().subtract(1, 'month').format('YYYY-MM-DD')
            }
            this.monthRange = [month, month]
          }
          break

        default:
          break
      }

      this.query()
    },
    disabledDate(date) {
      return date && date.valueOf() > Date.now() - 1000 * 60 * 60 * 24
    },

    onDateRangeChange(v) {
      this.query()
    },
    filterData(params) {
      const addDimens = []
      // 4.22.1 选中维度col fixed
      for (const k in params) {
        if (params[k]) dimensionsData.map((i) => k === i.showKey && addDimens.push({ ...i }))
      }

      this.addOnDimensions = addDimens

      this.pageIndex = 1
      this.tableList = []
      this.getData(params)
    },
    getDateType(dateType) {
      let title
      switch (dateType) {
        case DATE_TYPE.DAY:
          title = '分日'
          break
        case DATE_TYPE.WEEK:
          title = '分周'
          break
        case DATE_TYPE.MONTH:
          title = '分月'
          break
        case DATE_TYPE.TOTAL:
          title = '汇总'
          break
        case DATE_TYPE.HOUR:
          title = '分时'
          break
      }
      return title
    },
    onSaveRequest() {
      this.$nextTick(() => {
        const params = this.$refs.filter.buildParams()
        this.$refs.queryParamsManager.openSaveDialog(params)
      })
    },
    onConditionSelect(cond) {
      if (this.$refs.filter && cond) {
        const { id, conditionInfo } = cond
        if (!isEmpty(conditionInfo)) {
          const {
            initProjectGroupIds,
            adAccountIdList,
            gameIds,
            gameGroupIds,
            opIds,
            advPositionIds,
            optimizationTypes,
            deepOptimizationTypes,
            mediaIds,
            subMediaIds,
            platforms,
            launchSource,
            ptomPlan,
            ptomImage,
            launchModes,
            biddingStrategys,
            nativeAdverts,
            douyinNos,
            shipinNos,
            kuanshouNos,
            proxyAccountIds,
            proxyFlag,
            genders,
            deliveryTypes
          } = JSON.parse(conditionInfo)

          this.$nextTick(() => {
            Object.assign(this.$refs.filter, {
              initProjectGroupIds: initProjectGroupIds || [],
              adAccountIdList: adAccountIdList || [],
              gameIds: gameIds || [],
              gameGroupIds: gameGroupIds || [],
              opIds: opIds || [],
              advPositionIds: advPositionIds || [],
              optimizationTypes: optimizationTypes || [],
              deepOptimizationTypes: deepOptimizationTypes || [],
              mediaIds: mediaIds || [],
              subMediaIds: subMediaIds || [],
              platforms: platforms || [],
              launchSource: launchSource || '',
              planTagLists: ptomPlan || [],
              imageTagLists: ptomImage || [],
              launchModes: launchModes || [],
              biddingStrategys: biddingStrategys || [],
              nativeAdverts: nativeAdverts || [],
              douyinNos: douyinNos || [],
              shipinNos: shipinNos || [],
              kuanshouNos: kuanshouNos || [],
              proxyAccountIds: proxyAccountIds || [],
              proxyFlag: proxyFlag || '',
              genders: genders ? genders[0] : '',
              deliveryTypes: deliveryTypes || []
            })
          })
          const checkAllArr = [
            'dimPlan',
            'dimImage',
            'dimPlatform',
            'dimGameGroup',
            'dimGame',
            'dimProjectGroup',
            'dimOp',
            'dimMedia',
            'dimSubMedia',
            'dimAdvPosition',
            'dimAdAccount',
            'dimProxyAccount',
            'dimOptimizationType',
            'dimDeepOptimizationType',
            'dimLaunchSource',
            'dimLaunchMode',
            'dimBiddingStrategy',
            'dimNativeAdvert',
            'dimDouyinNo',
            'dimShipinNo',
            'dimKuanshouNo',
            'dimDeliveryType'
          ]
          const checkedBack = []
          this.$refs.filter.checkedDimens = []
          for (const k in this.$refs.filter.checkedParams) {
            // 选择常用查询条件时重置维度选择
            this.$set(this.$refs.filter.checkedParams, k, 0)
          }
          for (const k in JSON.parse(conditionInfo)) {
            checkAllArr.forEach((item) => {
              if (item === k) {
                checkedBack.push(item)
                this.$set(this.$refs.filter.checkedParams, item, 1)
              }
            })
            this.checkedDataForComplex.forEach((item) => {
              if (k && item.key === k) {
                this.$refs.filter.checkedDimens.push(item.label)
              }
              if (k && k === 'dimMedia') {
                this.$set(item, 'disabled', false)
              }
            })
          }
          this.$refs.filter.setDimensions(checkedBack)
          this.$refs.filter.checkAll = checkedBack.length === checkAllArr.length
          this.$refs.filter.isIndeterminate = checkedBack.length && checkedBack.length !== checkAllArr.length
        }
      }
    },
    getData(filter) {
      if (this.loading) return

      const [beginDate, endDate] = this.datetime || []
      let dates = { beginDate, endDate }

      if (this.dateType === 2) {
        console.log('this.weekRange output: ', this.weekRange)
        const [b, e] = this.weekRange.map((d) => moment(d).format('YYYY-MM-DD'))

        dates = { beginDate: b, endDate: e }
      }

      if (this.dateType === 3) {
        const [b, e] = this.monthRange.map((d) => moment(d).format('YYYY-MM-DD'))
        dates = { beginDate: b, endDate: e }
      }
      let params = {
        ...dates,
        pageIndex: this.pageIndex,
        pageSize: this.pageSizePrivate,
        sort: this.sort,
        order: this.order,
        dateType: this.dateType,
        limitConsumption: this.emptyFilterSwitch ? 1 : 0
      }
      if (this.middleWareFlag === 1) {
        params.middleWareFlag = this.middleWareFlag
      }

      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      // 保存参数
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getComplexReport(params).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (!data) return
        const { list, page_info, sum_data } = data
        sum_data && (this.sumdata = sum_data)

        if (list) {
          this.tableList = list.map((item) => {
            // 处理抖音显示名称，如果name不存在，则显示douyinNo
            return { ...item, douyinName: item.douyinName || item.douyinNo, kuanshouName: item.kuanshouName || item.kuanshouNo }
          })
        }
        if (page_info) {
          const { total_number } = page_info
          this.total = total_number || 0
        } else this.tableList = []
        this.$nextTick(() => {
          const tableRef = this.$refs.planDataTable

          if (tableRef) {
            tableRef.doLayout()

            // 完成查询后横向滚动条滚动一像素，处理表格从没有数据到有数据且scrollLeft>0时表格错位问题
            const el = tableRef.$el.querySelector('.el-table__body-wrapper')
            if (el) {
              el.scrollLeft -= 1
            }
          }
        })
      })
    },
    downData() {
      const exportColumnOrderMap = {}
      this.tableCols.forEach((col) => {
        if ((col.checked || col.type === 'disabled') && !col.exclude_export) exportColumnOrderMap[col.key] = col.title
      })
      const conditionText = this.$refs.filter.getTransferedTaskQueryConditions(this.params, REPORT_COMPLEX)
      const params = Object.assign(this.params, {
        firstTime: new Date().getTime(),
        exportColumnOrderMap,
        conditionText
      })
      this.exportLoading = true

      initDownloadCenterTask({
        pageType: REPORT_COMPLEX,
        queryCondition: params
      }).then((data) => {
        this.exportLoading = false
        if (data.msg) {
          this.$Message.success(data.msg)
          this.$store.commit('setDownloadBadgeActive', 1)
        }
      })
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (data[prop] && (prop.indexOf('Rate') > -1 || prop.indexOf('Retain') > -1 || prop.indexOf('Roi') > -1)) {
          sums[index] = toPercentFixed(data[prop])
        } else if (thousands.includes(prop)) sums[index] = toThousands(data[prop])
        else sums[index] = data[prop]
      })
      return sums
    },
    handleShow(param) {
      const { key, row } = param
      let src
      if (key === 'imageName') {
        src = row.imageAddr
        const videoUrl = row.videoUrl
        const video = !isEmpty(videoUrl)
        this.$Gallery.open({ src, video, videoUrl })
      }
    },
    changePageSizePrivate(size) {
      this.pageSizePrivate = size
      if (this.pageIndex === 1) this.getData()
    },
    sendSaveClick() {
      this.$nextTick(() => {
        this.$refs.filter && this.$refs.filter.saveFilter()
      })
    },

    /**
     * @description: 游戏等级通过率设置
     * @return {*}
     */
    showGameLevelSetting() {
      this.gameLevelSettingModal = true
      getGamePassLevelConfig().then((data) => {
        this.gameLevelForm.rows =
          data?.map((row) => ({
            middleGameIds: row.mgameId,
            platform: row.platform,
            level: row.levelPass,
            hourLevelPass: row.hourLevelPass
          })) || []
      })
    },
    onGameLevelSettingConfirm() {
      this.$refs['game-level-form'].validate((valid) => {
        if (valid) {
          this.gameLevelForm.loading = true
          const passConfigs = this.gameLevelForm.rows.map((row) => ({
            mgame_id: row.middleGameIds,
            platform: row.platform,
            level_pass: row.level,
            hourLevelPass: row.hourLevelPass
          }))
          setGameLevel({ passConfigs })
            .then((data) => {
              if (data) {
                this.$Message.success('更新成功')
                this.closeGameLevelSettingModal()
              } else {
                this.gameLevelForm.loading = false
              }
            })
            .catch(() => {
              this.gameLevelForm.loading = false
            })
        }
      })
    },
    closeGameLevelSettingModal() {
      this.gameLevelSettingModal = false
      this.gameLevelForm = {
        loading: false,
        rows: [getGameLevelRow()]
      }
    },
    onAddGameLevelRow() {
      this.gameLevelForm.rows.push(getGameLevelRow())

      // 添加游戏行后，使最后添加的行出现在视口范围内
      this.$nextTick(() => {
        const [lastFormItem] = Array.from(document.querySelector('.game-level-form').querySelectorAll('.el-form-item')).slice(-1)
        if (lastFormItem) {
          lastFormItem.scrollIntoView()
        }
      })
    },
    onGameLevelRowRemove(rowIndex) {
      this.gameLevelForm.rows.splice(rowIndex, 1)
    },

    proLoadData() {
      // 中间件游戏
      Promise.all([getMiddleGameList()].map((p) => p.catch((err) => err)))
        .then((data) => {
          const [midGameData] = data
          this.midGameData = midGameData
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    },

    async onCustomColumnChange(columns) {
      this.toggleTableColLoading = true
      await new Promise((resolve) => {
        setTimeout(resolve, 100)
      })
      this.tableColumns = columns
      this.toggleTableColLoading = false
    },
    headerDragend({ n, o, column }) {
      this.$refs.tableCustomColsRef.updateTableColWidth(n, column)
    }
  },
  data() {
    const gameLevelValidator = (rule, value, callback) => {
      const [, rowIndex] = rule.fullField.split('.')
      const row = this.gameLevelForm.rows[rowIndex]
      if (row) {
        const { level, middleGameIds, platform, hourLevelPass } = row
        if (!middleGameIds) return callback(new Error('请选择游戏'))
        if (!platform) return callback(new Error('请选择平台'))
        if (isEmpty(level)) callback(new Error('请输入游戏等级'))
        else if (isNaN(level)) callback(new Error('请输入有效数字'))
        else if (level % 1 !== 0) callback(new Error('请输入正整数的游戏等级'))
        else if (level < 0 || level > 10000) {
          return callback(new Error('游戏等级在0-9999之间'))
        }

        if (isEmpty(hourLevelPass)) callback(new Error('请输入游戏等级'))
        else if (isNaN(hourLevelPass)) callback(new Error('请输入有效数字'))
        else if (hourLevelPass % 1 !== 0) callback(new Error('请输入正整数的游戏等级'))
        else if (hourLevelPass < 0 || hourLevelPass > 10000) {
          return callback(new Error('游戏等级在0-9999之间'))
        }

        callback()
      } else {
        callback(new Error('等级设置错误'))
      }
    }

    return {
      // 自定义列弹窗的左侧导航菜单
      defaultTableColNavs: NAVS,
      // 全部的列数据
      defaultTableCols: DEFAULT_COLS,
      middleWareFlag: 0,
      dateType: 1,
      tableColumns: [],
      addOnDimensions: [],
      toggleTableColLoading: false,
      datetime: [],
      weekRange: [],
      monthRange: [],
      DATE_TYPE,
      tableHeight: 330,
      pageSizePrivate: 20, // 自定义默认页面尺寸
      tableList: [], // 表格数据
      sumdata: [], // 合计数据
      midGameData: [], // 中间件游戏列表， 游戏等级通关率设置弹窗下拉数据
      // 游戏等级通关率
      gameLevelForm: {
        loading: false,
        rows: [getGameLevelRow()]
      },
      gameLevelRules: [{ validator: gameLevelValidator, trigger: 'blur' }],

      emptyFilterSwitch: false,
      gameLevelSettingModal: false, // 游戏等级通关率设置modal
      weekOptions: {
        firstDayOfWeek: 1,
        cellClassName: (date) => {
          if (date && date.valueOf() > Date.now() - 1000 * 60 * 60 * 24) return 'empty-date'
          return ''
        },
        disabledDate: (date) => {
          const isMonday = new Date().getDay() === 1
          if (isMonday) {
            return date && date.valueOf() > Date.now() - 1000 * 60 * 60 * 24
          }
          return date && date.valueOf() > Date.now() + (7 - new Date().getDay()) * 1000 * 60 * 60 * 24
        }
      },
      monthOptions: {
        disabledDate: this.disabledDate
      },
      checkedDataForComplex,
      exportLoading: false,
      WeekDefaultShow: '',
      MonthDefaultShow: ''
    }
  },
  mounted() {
    this.WeekDefaultShow = new Date()
    this.MonthDefaultShow = new Date()
    this.WeekDefaultShow.setMonth(new Date().getMonth() - 1)
    this.MonthDefaultShow.setFullYear(new Date().getFullYear() - 1)
  },
  created() {
    const date = moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.datetime = [date, date]
    this.getData({})

    // this.tableList.length && this.getData()
    this.proLoadData()
  }
}
</script>
<style lang="scss" scoped>
.c-material-report {
  height: 100%;

  .c-btn-group {
    line-height: 30px;
    height: 32px;
    border-radius: 3px;
    width: 100px;
    display: inline-block;
    vertical-align: middle;
  }

  // 游戏等级通关率设置
  ::v-deep .game-level-modal {
    .el-dialog__body {
      padding-bottom: 0;
    }
    .game-level-form {
      max-height: 370px;
      overflow: auto;
      padding-right: 5px;
    }

    .add-row {
      margin-left: 74px;
    }
    .title-row {
      display: flex;
      background: #f6f6f6;

      h3 {
        padding: 0 10px;
        font-size: 14px;
        font-weight: 600;

        &:nth-of-type(1) {
          min-width: 130px;
        }
        &:nth-of-type(2) {
          min-width: 130px;
        }
        &:nth-of-type(3) {
          min-width: 190px;
        }
      }
    }

    .game-row {
      display: flex;
      justify-content: space-between;
      .selector {
        display: flex;
        .el-select {
          flex: 1;
          margin-right: 5px;
        }
        .el-input {
          flex-basis: 25%;
        }
        .suffix {
          flex-basis: 5%;
        }
      }

      .btns {
        span {
          cursor: pointer;
          margin-left: 10px;
        }
      }
    }
  }

  .c-table-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;

    .right-btns {
      display: flex;
      align-items: center;
      .empty-data-filter {
        margin-right: 5px;
        display: flex;
        align-items: center;
      }

      .date-type-radio {
        margin-right: 5px;
      }
      .date-picker-wrapper {
        margin-right: 5px;
      }

      .week-range .el-date-table th {
        text-align: center;
      }
    }
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
